// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { AppConfig } from './declarations';

const config = require("../assets/scripts/UrlApi.json");

export const environment: AppConfig = {
  production: false,
  liveEnterprise: false,
  url: config.urlLocal,
  reportsKey: '68435AEB20F7457DAEC97D9BC669C19B',
  barcloudUrl: config.barcloudUrlLocal,
  app: { name: 'Enterprise' },
  api: { urls: { enterpriseApi: config.enterpriseApiLocal } }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
